/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    var _handlePosts = handlePosts(state.posts, state.postsInChannel, action),
        posts = _handlePosts.posts,
        postsInChannel = _handlePosts.postsInChannel;

    var nextState = {

        // Object mapping post ids to post objects
        posts: posts,

        // Object mapping channel ids to an list of posts ids in that channel with the most recent post first
        postsInChannel: postsInChannel,

        // The current selected post
        selectedPostId: selectedPostId(state.selectedPostId, action),

        // The current selected focused post (permalink view)
        currentFocusedPostId: currentFocusedPostId(state.currentFocusedPostId, action),

        // Object mapping post ids to an object of emoji reactions using userId-emojiName as keys
        reactions: reactions(state.reactions, action),

        // Object mapping URLs to their relevant opengraph metadata for link previews
        openGraph: openGraph(state.openGraph, action)
    };

    if (state.posts === nextState.posts && state.postsInChannel === nextState.postsInChannel && state.selectedPostId === nextState.selectedPostId && state.currentFocusedPostId === nextState.currentFocusedPostId && state.reactions === nextState.reactions && state.openGraph === nextState.openGraph) {
        // None of the children have changed so don't even let the parent object change
        return state;
    }

    return nextState;
};

var _action_types = require('../../action_types');

var _constants = require('../../constants');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function handleReceivedPost() {
    var posts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var postsInChannel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var action = arguments[2];

    var post = action.data;
    var channelId = post.channel_id;

    var nextPosts = _extends({}, posts, _defineProperty({}, post.id, post));

    var nextPostsForChannel = postsInChannel;

    // Only change postsInChannel if the order of the posts needs to change
    if (!postsInChannel[channelId] || postsInChannel[channelId].indexOf(post.id) === -1) {
        // If we don't already have the post, assume it's the most recent one
        var postsForChannel = postsInChannel[channelId] || [];

        nextPostsForChannel = _extends({}, postsInChannel);
        nextPostsForChannel[channelId] = [post.id].concat(_toConsumableArray(postsForChannel));
    }

    return { posts: nextPosts, postsInChannel: nextPostsForChannel };
}

function handleReceivedPosts() {
    var posts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var postsInChannel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var action = arguments[2];

    var newPosts = action.data.posts;
    var channelId = action.channelId;

    var nextPosts = _extends({}, posts);
    var nextPostsForChannel = _extends({}, postsInChannel);
    var postsForChannel = postsInChannel[channelId] ? [].concat(_toConsumableArray(postsInChannel[channelId])) : [];

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = Object.values(newPosts)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var newPost = _step.value;

            if (newPost.delete_at > 0) {
                // Mark the post as deleted if we have it
                if (nextPosts[newPost.id]) {
                    nextPosts[newPost.id] = _extends({}, newPost, {
                        state: _constants.Posts.POST_DELETED,
                        file_ids: [],
                        has_reactions: false
                    });
                } else {
                    continue;
                }
            }

            // Only change the stored post if it's changed since we last received it
            if (!nextPosts[newPost.id] || nextPosts[newPost.id].update_at < newPost.update_at) {
                nextPosts[newPost.id] = newPost;
            }

            if (postsForChannel.indexOf(newPost.id) === -1) {
                // Just add the post id to the end of the order and we'll sort it out later
                postsForChannel.push(newPost.id);
            }

            // Remove any temporary posts
            if (nextPosts[newPost.pending_post_id]) {
                Reflect.deleteProperty(nextPosts, newPost.pending_post_id);

                var index = postsForChannel.indexOf(newPost.pending_post_id);
                if (index !== -1) {
                    postsForChannel.splice(index, 1);
                }
            }
        }

        // Sort to ensure that the most recent posts are first
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    postsForChannel.sort(function (a, b) {
        if (nextPosts[a].create_at > nextPosts[b].create_at) {
            return -1;
        } else if (nextPosts[a].create_at < nextPosts[b].create_at) {
            return 1;
        }

        return 0;
    });

    nextPostsForChannel[channelId] = postsForChannel;

    return { posts: nextPosts, postsInChannel: nextPostsForChannel };
}

function handlePostDeleted() {
    var posts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var postsInChannel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var action = arguments[2];

    var post = action.data;
    var channelId = post.channel_id;

    var nextPosts = _extends({}, posts);
    var nextPostsForChannel = _extends({}, postsInChannel);

    // We only need to do something if already have the post
    if (posts[post.id]) {
        // Mark the post as deleted
        nextPosts[post.id] = _extends({}, posts[post.id], {
            state: _constants.Posts.POST_DELETED,
            file_ids: [],
            has_reactions: false
        });

        // Remove any of its comments
        var channelPosts = postsInChannel[channelId] ? [].concat(_toConsumableArray(postsInChannel[channelId])) : [];
        var postsForChannel = [].concat(_toConsumableArray(channelPosts)); // make sure we don't modify the array we loop over
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = channelPosts[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var id = _step2.value;

                if (nextPosts[id].root_id === post.id) {
                    Reflect.deleteProperty(nextPosts, id);

                    var commentIndex = postsForChannel.indexOf(id);
                    if (commentIndex !== -1) {
                        postsForChannel.splice(commentIndex, 1);
                    }
                }
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }

        nextPostsForChannel[channelId] = postsForChannel;
    }

    return { posts: nextPosts, postsInChannel: nextPostsForChannel };
}

function handleRemovePost() {
    var posts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var postsInChannel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var action = arguments[2];

    var post = action.data;
    var channelId = post.channel_id;

    var nextPosts = posts;
    var nextPostsForChannel = postsInChannel;

    // We only need to do something if already have the post
    if (nextPosts[post.id]) {
        nextPosts = _extends({}, posts);
        nextPostsForChannel = _extends({}, postsInChannel);
        var channelPosts = postsInChannel[channelId] ? [].concat(_toConsumableArray(postsInChannel[channelId])) : [];

        // Remove the post itself
        Reflect.deleteProperty(nextPosts, post.id);

        var index = channelPosts.indexOf(post.id);
        if (index !== -1) {
            channelPosts.splice(index, 1);
        }

        // Create a copy of the channelPosts after we splice the
        // parent post so we can safely loop and have the latest changes
        var postsForChannel = [].concat(_toConsumableArray(channelPosts));

        // Remove any of its comments
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
            for (var _iterator3 = channelPosts[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var id = _step3.value;

                if (nextPosts[id].root_id === post.id) {
                    Reflect.deleteProperty(nextPosts, id);

                    var commentIndex = postsForChannel.indexOf(id);
                    if (commentIndex !== -1) {
                        postsForChannel.splice(commentIndex, 1);
                    }
                }
            }
        } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                }
            } finally {
                if (_didIteratorError3) {
                    throw _iteratorError3;
                }
            }
        }

        nextPostsForChannel[channelId] = postsForChannel;
    }

    return { posts: nextPosts, postsInChannel: nextPostsForChannel };
}

function handlePosts() {
    var posts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var postsInChannel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var action = arguments[2];

    switch (action.type) {
        case _action_types.PostTypes.RECEIVED_POST:
            return handleReceivedPost(posts, postsInChannel, action);
        case _action_types.PostTypes.RECEIVED_POSTS:
            return handleReceivedPosts(posts, postsInChannel, action);
        case _action_types.PostTypes.POST_DELETED:
            if (action.data) {
                return handlePostDeleted(posts, postsInChannel, action);
            }
            return { posts: posts, postsInChannel: postsInChannel };
        case _action_types.PostTypes.REMOVE_POST:
            return handleRemovePost(posts, postsInChannel, action);

        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {
                posts: {},
                postsInChannel: {}
            };
        default:
            return {
                posts: posts,
                postsInChannel: postsInChannel
            };
    }
}

function selectedPostId() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var action = arguments[1];

    switch (action.type) {
        case _action_types.PostTypes.RECEIVED_POST_SELECTED:
            return action.data;
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return '';
        default:
            return state;
    }
}

function currentFocusedPostId() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var action = arguments[1];

    switch (action.type) {
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return '';
        default:
            return state;
    }
}

function reactions() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _action_types.PostTypes.RECEIVED_REACTIONS:
            {
                var reactionsList = action.data;
                var nextReactions = _extends({}, state[action.postId] || {});
                reactionsList.forEach(function (reaction) {
                    nextReactions[reaction.user_id + '-' + reaction.emoji_name] = reaction;
                });

                return _extends({}, state, _defineProperty({}, action.postId, nextReactions));
            }
        case _action_types.PostTypes.RECEIVED_REACTION:
            {
                var reaction = action.data;
                var _nextReactions = _extends({}, state[reaction.post_id] || {});
                _nextReactions[reaction.user_id + '-' + reaction.emoji_name] = reaction;

                return _extends({}, state, _defineProperty({}, reaction.post_id, _nextReactions));
            }
        case _action_types.PostTypes.REACTION_DELETED:
            {
                var _reaction = action.data;
                var _nextReactions2 = _extends({}, state[_reaction.post_id] || {});
                if (!_nextReactions2[_reaction.user_id + '-' + _reaction.emoji_name]) {
                    return state;
                }

                Reflect.deleteProperty(_nextReactions2, _reaction.user_id + '-' + _reaction.emoji_name);

                return _extends({}, state, _defineProperty({}, _reaction.post_id, _nextReactions2));
            }
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};
        default:
            return state;
    }
}

function openGraph() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _action_types.PostTypes.RECEIVED_OPEN_GRAPH_METADATA:
            {
                var nextState = _extends({}, state);
                nextState[action.url] = action.data;

                return nextState;
            }
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};
        default:
            return state;
    }
}



//////////////////
// WEBPACK FOOTER
// ./~/mattermost-redux/reducers/entities/posts.js
// module id = 1213
// module chunks = 60